export default __webpack_public_path__ + "static/media/encuestas.47366f6e.svg";